module.exports = __webpack_public_path__ + "static/img/yytx19.caec87b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/yytx19.png
// module id = 891
// module chunks = 0